import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Image from "react-bootstrap/Image";
import PhoneInput from 'react-phone-input-2';
import Dropdown from 'react-select';
import * as actionCreators from "../store/actions"
import countries from "../store/data/countries"




// IMAGES
import UserOutline from "../images/svgs/UserOutline.svg";
import EmailOutline from "../images/svgs/EmailOutline.svg";
import PhoneOutline from "../images/svgs/PhoneOutline.svg";
import LocationOutline01 from "../images/svgs/LocationOutline01.svg";
import Back from "../images/svgs/Back.svg";

// const shippingMethods = [{
//   name: "DHL",
//   descp: "1-2 Day shipping inside Kuwait",
//   price: "FREE",
//   currency: "",
//   id: 0
// }, {
//   name: "DHL GCC",
//   descp: "5-7 Day shipping inside GCC",
//   price: "5",
//   currency: "KWD",
//   id: 1
// }]

const shipmentSteps = [{
  id: 1,
  name: "Shipping"
}, {
  id: 2,
  name: "Payment"
}, {
  id: 3,
  name: "Done"
}]

const addressTypes = [{
  id: "01",
  name: "House"
}, {
  id: "02",
  name: "Appartment"
}, {
  id: "03",
  name: "Office"
}]

const shippingFeesCountry = [{
  country: "kw",
  currency: "KWD",
  fees: 5,

}, {
  country: "sa",
  currency: "SAR",
  fees: 60,

}, {
  country: "om",
  currency: "OMR",
  fees: 7,

}, {
  country: "bh",
  currency: "BHD",
  fees: 15,

}, {
  country: "ae",
  currency: "AED",
  fees: 25,

}, {
  country: "qa",
  currency: "QAR",
  fees: 75,

}];

class Address extends React.Component {
  state = {
    phone: "",
    activeShipment: 0,
    activeStep: 1,
    country: "kw",
    area: "",
    addressType: "01"
  }
  componentDidMount() {
    this.props.setUserLocation();
    this.setDefaultCountrySameAsLocationInCurrency()
    this.props.myCartList();
    this.props.getTotalAmountDetail();
    if (this.props.cartList && this.props.cartList.length > 0) {
      // window.dataLayer.push({
      //   'event': 'begin_checkout',
      //   'ecommerce': {
      //     'items': this.props.cartList.map(item => {
      //       return {
      //         'item_id': item.id,
      //         'item_name': item.name,
      //         'quantity': item.quantity,
      //         'price': item.price,
      //         'item_unit_price': parseFloat (item.unit_price)
      //       }
      //     })
      //   }
      // });
      window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': 1 },
            'products': this.props.cartList.map(item => {
              return {
                'id': item.id,
                'name': item.name,
                'quantity': item.quantity,
                'price': item.price,
                'unit_price': parseFloat (item.unit_price)
              }
            })
          }
        }
      })
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.currency && prevProps.currency !== this.props.currency) {
      this.setDefaultCountrySameAsLocationInCurrency()
    }
  }


  setDefaultCountrySameAsLocationInCurrency = () => {
    let country = "kw"
    switch (this.props.currency) {
      case "KWD":
        country = "kw";
        break;
      case "SAR":
        country = "sa";
        break;
      case "BHD":
        country = "bh";
        break;
      case "OMR":
        country = "om";
        break;
      case "AED":
        country = "ae";
        break;
      case "QAR":
        country = "qa";
        break;
      default:
        country = "kw"
        break;
    }
    this.setState({
      country: country
    })
  }
  goBack = () => {
    this.props.history.goBack();
  }

  handleCountryChange = (country) => {
    this.setState({
      country: country.target.value,
      area: ""
    })
  }

  onAreaChange = (area) => {
    this.setState({
      area
    })
  }

  handleAddressTypeChange = (event) => {
    this.setState({
      addressType: event.target.value
    })
  }

  getShippingFees = () => {
    return shippingFeesCountry.find(shipment => shipment.country === this.state.country)
  }
  render() {
    document.body.classList.remove('inner-page');
    // const translate = this.props.translate;
    return <div className={"addressDiv"}>
      <div className={"addressHeader"}>
        <Image onClick={this.goBack} className={"addressBackBtn"} src={Back} />
        <h4 className={"addressText"}>{"Checkout"}</h4>
        <div className={"stepsHeaderView"}>
          {shipmentSteps.map(step =>
            <div className={"stepInfoOuterView"} key={step.id}>
              <div className={"stepInfo"}>
                <div className={`stepNumber ${step.id === this.state.activeStep && "activeStepNumber"}`}>{step.id}</div>
                <p className={`stepName ${step.id === this.state.activeStep && "activeStep"}`}>{step.name}</p>
              </div>
              {step.id !== 3 &&
                <span className={`horizontalLineStep ${step.id === 1 && "horizontalRight"}`}></span>}
            </div>
          )}
        </div>
      </div>
      <div className={"addressOuterView"}>
        <h4 className={"addressSubHeading"}>Shipping Info</h4>
        <div className={"addressAreaField"}>
          <Image className={"locationIcon"} src={UserOutline} />
          <div className={"areaDiv"}>
            <span className={"addressLabel"}>
              {"Full Name"}
            </span>
            <div className={"fullNameDiv"}>
              <input className={"addressInput firstName "} placeholder={"First Name"} />
              <input className={"addressInput lastName"} placeholder={"Last Name"} />
            </div>
          </div>
        </div>

        <div className={"addressAreaField"}>
          <Image className={"locationIcon"} src={EmailOutline} />
          <div className={"areaDiv"}>
            <span className={"addressLabel"}>
              {"Email"}
            </span>
            <input className={"addressInput "} type={"email"} placeholder={"Email"} />

          </div>
        </div>
        <div className={"addressAreaField"}>
          <Image className={"phoneIcon"} src={PhoneOutline} />
          <div className={"areaDiv"}>
            <span className={"addressLabel"}>
              {'PHONE NUMBER'}
            </span>
            <PhoneInput
              defaultCountry={this.state.country}
              onlyCountries={["kw", "sa", "qa", "ae", "bh", "om"]}
              value={this.state.phone}
              onChange={phone => this.setState({ phone })}
              className={"addressInput"}
            />
          </div>
        </div>


        <div className={"addressAreaField"}>
          <Image className={"locationIcon"} src={LocationOutline01} />
          <div className={"areaDiv"}>
            <span className={"addressLabel"}>
              {"Country"}
            </span>
            <select defaultValue={this.state.country} className={"addressInput"} onChange={this.handleCountryChange} >
              <option disabled={true}>{'Select Country'}</option>
              {
                countries.map(country =>
                  <option
                    disabled={country.country_code !== this.state.country}
                    key={country.country_code}
                    value={country.country_code}>
                    {country.label}
                  </option>)
              }
            </select>
          </div>
        </div>

        <div className={"addressAreaField"}>
          <Image className={"locationIcon"} src={LocationOutline01} />
          <div className={"areaDiv"}>
            <span className={"addressLabel"}>
              {"AREA"}
            </span>
            <Dropdown
              options={countries[countries.findIndex(ctr => ctr.country_code === this.state.country)].list}
              onChange={this.onAreaChange} value={this.state.area}
              placeholder="Select an Area" />
          </div>
        </div>
        <div className={"addressAreaField"}>
          <Image className={"locationIcon"} src={LocationOutline01} />
          <div className={"areaDiv"}>
            <span className={"addressLabel"}>
              {"Address Type"}
            </span>

            <select
              defaultValue={"Select Adress Type"}
              className={"addressInput"}
              onChange={this.handleAddressTypeChange} >
              <option disabled={true}>{'Select Adress Type'}</option>
              {
                addressTypes.map(address =>
                  <option
                    key={address.id}
                    value={address.id}>
                    {address.name}
                  </option>)
              }
            </select>
          </div>
        </div>

        <div className={"wrapAddressDiv"}>
          <div className={"addressFieldDiv"}>
            <span className={"addressLabel"}>
              {"BLOCK"}
            </span>
            <input className={"addressInput"} />

          </div>
          <div className={"addressFieldDiv"}>
            <span className={"addressLabel"}>
              {"STREET"}
            </span>
            <input className={"addressInput"} />

          </div>
          <div className={"addressFieldDiv"}>
            <span className={"addressLabel"}>
              {(this.state.addressType === "02" || this.state.addressType === "03") && "BUILDING"}
              {(this.state.addressType === "01") && "HOUSE"}
            </span>
            <input className={"addressInput"} />

          </div>
          <div className={"addressFieldDiv"}>
            <span className={"addressLabel"}>
              {"AVENUE"}
            </span>
            <input className={"addressInput"} />

          </div>

          {(this.state.addressType === "03" || this.state.addressType === "02") &&
            <div className={"addressFieldDiv"}>
              <span className={"addressLabel"}>
                {"FLOOR"}
              </span>
              <input className={"addressInput"} />

            </div>
          }
          {this.state.addressType === "03" &&
            <div className={"addressFieldDiv"}>
              <span className={"addressLabel"}>
                {"OFFICE"}
              </span>
              <input className={"addressInput"} />
            </div>
          }
          {this.state.addressType === "02" &&
            <div className={"addressFieldDiv"}>
              <span className={"addressLabel"}>
                {"Apartment no."}
              </span>
              <input className={"addressInput"} />
            </div>
          }
        </div>
        <div className={"addressInput addressInputFull addressAreaField"}>
          <span className={"addressLabel"}>
            {"ADDITIONAL DIRECTIONS"}
          </span>
          <input className={"addressInput"} />
        </div>
      </div>
      {/* <div className={"shipmentOuterDiv"}>
        <h4 className={"addressSubHeading"}>Shipping Method</h4>
        {shippingMethods.map(method =>
          <div
            key={method.id}
            className={"shipmentMethodRow"}
            onClick={() => {
              this.setState({
                activeShipment: method.id
              })
            }}>
            <span className={`shipmentRadioBtn`}>
              {this.state.activeShipment === method.id && <span className={"activeShipmentRadioBtn"}></span>}
            </span>
            <div className={"shipmentType"}>
              <h5 className={"shipmentTypeName"}>{method.name}</h5>
              <p className={"shipmentTypeDesc"}>{method.descp}</p>
            </div>
            <h3 className={"shipmentAmount"} >
              <span>
                {method.currency}
              </span>
              {method.price}
            </h3>
          </div>)}

      </div> */}

      <div className={"proceedToPaymentBottomView"}>
        <div className={"totalPriceView subTotalView"}>
          <h5 className={"shippingFeeText"}>
            {"Shipping Fee :"}
          </h5>
          <h5 className={"totalPriceAmountSubText"}>
            <span>{this.getShippingFees().currency} </span>
            {this.getShippingFees().fees}
          </h5>
        </div>
        <div className={"totalPriceView subTotalView"}>
          <h5 className={"shippingFeeText"}>
            {"Cart Subtotal :"}
          </h5>
          <h5 className={"totalPriceAmountSubText"}>
            <span>{this.props.currency} </span>
            {this.props.totalCartAmount}
          </h5>
        </div>
        <div className={"totalPriceView"}>
          <h5 className={"totalPriceText"}>
            {"Total :"}
          </h5>
          <h5 className={"totalPriceAmountText"}>
            <span>{this.props.currency} </span>
            {this.props.totalPaymentWithShipmentFees}
          </h5>
        </div>
        <button className={"checkoutButton"} onClick={() => { this.props.history.push("/clientwebsite2/paymentselect") }}>
          {'Proceed to payment'}
        </button>
      </div>
    </div>
  }
}
const mapDispatchToProps = dispatch => ({
  myCartList: () => dispatch(actionCreators.myCartList()),
  setUserLocation: () => dispatch(actionCreators.setUserLocation()),
  getTotalAmountDetail: () => dispatch(actionCreators.getTotalAmountDetail())
});
const mapStateToProps = state => ({

  pathname: state.login.pathname,
  translate: state.websiteLanguage.translations,
  featuredProductsList: state.campaign.featuredProductsList,
  popularProductsList: state.campaign.popularProductsList,
  explore_products: state.campaign.explore_products,
  currency: state.login.currency,
  cartList: state.cart.cartList,
  totalCartAmount: state.cart.totalCartAmount,
  totalPaymentWithShipmentFees: state.cart.totalPaymentWithShipmentFees
});
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Address));



// WEBPACK FOOTER //
// ./src/pages/Address.js